import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import Api from "@/services/api"
    import { Car, Route, Travel } from "@/services/types";
import { toFormData } from "@/utilities/helpers";
    import { ElMessage, FormInstance, FormRules, ElSelectV2, ElDatePicker } from "element-plus"
    import { OptionType } from "element-plus/es/components/select-v2/src/select.types";
    import { reactive, ref, computed } from "vue"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTravel',
  props: {
    routes: {},
    cars: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props
    const emit = __emit

    const routes = computed<Array<OptionType>>(() => {
        return props.routes.map((value: Route) => {
            return {value: value.id, label: `${value.name}`}
        })
    })

    const cars = computed<Array<OptionType>>(() => {
        return props.cars.map((value: Car) => {
            return {value: value.id, label: `${value.name} [${value.plate}]`}
        })
    })

    const travels = ref<Array<Travel>>([{
        car_id: 0,
        departure: new Date(),
        route_id: 0,
    }])

    const rules = reactive<FormRules>({
        'travels': [{ required: true, type: 'array', message: 'Adicione pelo menos uma viagem', trigger: 'change' }],
        'travels.*.car_id': [{ required: true, message: 'Escolha um carro', trigger: 'change' }],
        'travels.*.departure': [{ required: true, message: 'Escolha a hora de partida', trigger: 'change' }],
        'travels.*.route_id': [{ required: true, message: 'Escolha uma rota', trigger: 'change' }],
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const addTravel = () => {
        travels.value.push({
            car_id: 0,
            departure: new Date(),
            route_id: 0,
        });
    };

    const removeTravel = (index: number) => {
        travels.value.splice(index, 1);
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const fd = toFormData({travels: travels.value})
                const res = await Api.post(`admin/travel`, {travels: travels.value}, fd)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Carro cadastrado com sucesso'})
                    emit('close')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    disabled: saving.value,
    rules: rules,
    model: { travels: travels.value },
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(travels.value, (travel, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          style: {"margin-bottom":"24px","border":"1px solid #ccc","padding":"16px","border-radius":"8px"}
        }, [
          _createVNode(_component_el_form_item, {
            prop: `travels.${i}.route_id`,
            label: "Rota de viagem"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelectV2), {
                clearable: false,
                filterable: "",
                loading: saving.value,
                name: "route_id[]",
                modelValue: travel.route_id,
                "onUpdate:modelValue": ($event: any) => ((travel.route_id) = $event),
                options: routes.value
              }, null, 8, ["loading", "modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_component_el_form_item, {
            prop: `travels.${i}.car_id`,
            label: "Carro"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelectV2), {
                clearable: false,
                filterable: "",
                loading: saving.value,
                name: "car_id[]",
                modelValue: travel.car_id,
                "onUpdate:modelValue": ($event: any) => ((travel.car_id) = $event),
                options: cars.value
              }, null, 8, ["loading", "modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_component_el_form_item, {
            prop: `travels.${i}.departure`,
            label: "Hora de partida da Beira"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElDatePicker), {
                type: "datetime",
                format: "DD/MM/YYYY HH:mm:ss",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                name: "departure[]",
                clearable: false,
                modelValue: travel.departure,
                "onUpdate:modelValue": ($event: any) => ((travel.departure) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          (travels.value.length > 1)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: ($event: any) => (removeTravel(i))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Remover", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode(_component_el_button, {
        loading: saving.value,
        type: "success",
        icon: "Plus",
        onClick: _withModifiers(addTravel, ["prevent"])
      }, null, 8, ["loading"]),
      _createVNode(_component_el_button, {
        plain: "",
        loading: saving.value,
        size: "large",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Marcar viagens ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["disabled", "rules", "model"]))
}
}

})